import { useState } from "react";
import { Button, Col, Form, Input, Row } from "antd";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { apiUrl } from "../../Constant";
import { routes } from "../../Routes/Routes";
import logo from "../../Assets/PNG/logo.png";
import styles from "./index.module.scss";

function ForgotPassword() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const res = await axios.post(apiUrl.FORGOT_PASSWORD, {
        email: values.email,
      });
      if (res.data.type === "success") {
        setSent(true);
        toast.success("Reset link sent — check your email");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Row justify="center" className={styles.main}>
        <Col xl={7} xxl={7} className={styles.user}>
          <div className={styles.setuser}>
            <img
              src={logo}
              alt="The Diamond Counter"
              style={{ width: "100%", maxWidth: 220, marginBottom: 20 }}
            />

            <p className={styles.login}>Forgot Password</p>

            {sent ? (
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <p style={{ fontSize: 15, marginBottom: 16, lineHeight: 1.6 }}>
                  If an account exists with that email, we've sent a password
                  reset link. Please check your inbox and spam folder.
                </p>
                <Link
                  to={routes.loginUrl}
                  style={{ color: "#C5A028", fontWeight: 600 }}
                >
                  Back to Login
                </Link>
              </div>
            ) : (
              <Form
                form={form}
                name="forgot-password"
                onFinish={handleSubmit}
                autoComplete="off"
              >
                <p style={{ fontSize: 13, color: "#777", marginBottom: 16 }}>
                  Enter your email address and we'll send you a link to reset
                  your password.
                </p>

                <Form.Item
                  name="email"
                  className={styles.name}
                  rules={[
                    { required: true, message: "Email is required" },
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input placeholder="Email Address" className={styles.phone} />
                </Form.Item>

                <Form.Item className={styles.mainbtn}>
                  <Button
                    htmlType="submit"
                    className={styles.continue}
                    loading={loading}
                  >
                    Send Reset Link
                  </Button>
                </Form.Item>

                <p style={{ textAlign: "center" }}>
                  <Link
                    to={routes.loginUrl}
                    style={{ color: "#C5A028", fontWeight: 600 }}
                  >
                    Back to Login
                  </Link>
                </p>
              </Form>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ForgotPassword;
